<template>
  <div>
    <list-template
        :current-page="page"
        :loading="loading"
        :search-config="searchConfig"
        :table-config="tableConfig"
        :table-data="tableData"
        :total="total"
        has-add
        @onAdd="$router.push('./add?id=2')"
        @onChangePage="handleCurrentChange"
        @onExportData="exportData"
        @onHandle="handleEdit"
        @onReset="onReset"
        @onSearch="onSearch"
        @onChange="onChange"
    ></list-template>
  </div>
</template>

<script>
//引入ajax接口管理层的接口函数
import {mapState} from "vuex";
import {deepCopy} from "@/utils/l-tools";
import tools from "@/utils/tools";
import { getConfigValue, setConfigValue } from '@/utils'

export default {
  _config: {"route": {"path": "list", "meta": {"title": "列表", "keepAlive": true}}},
  data() {
    return {
      loading: true,
      search: {},
      searchConfig: [
        {
          prop: "student_name",
          placeholder: "搜索学生姓名"
        },
        {
          prop: "student_no",
          placeholder: "搜索学生学号"
        },
        {
          prop: "school_id",
          tag: 'select',
          placeholder: "筛选就读校区",
          label: 'school_name',
          value: 'id',
          options: [],
          change: (val, search) => {
            this.getClass(search)
          }
        },
        {
          prop: "grade_id",
          tag: 'select',
          placeholder: "筛选年级",
          label: 'name',
          value: 'id',
          options: [],
          change: (val, search) => {
            this.getClass(search)
          }
        },
        {
          prop: "class_id",
          tag: 'select',
          placeholder: "筛选行政班",
          label: 'class_name',
          value: 'class_id',
          options: [],
        },
        {
          prop: "status",
          tag: 'select',
          placeholder: "筛选学生状态",
          options: [
            {
              label: "休学中",
              value: 1
            },
            {
              label: "已复学",
              value: 2
            }
          ],
        },
      ],
      tableData: [],
      total: 0,
      tableConfig: [
        {"prop": "student_name", "label": "学生姓名"},
        {"prop": "student_no", "label": "学号"},
        {"prop": "school_name", "label": "就读校区"},
        {"prop": "grade_name", "label": "年级"},
        {"prop": "class_name", "label": "行政班"},
        {"prop": "start_time", "label": "休学时间"},
        {
          "prop": "status_name", "label": "学生状态", render: (row) => {
            return Number(row['status']) === 1 ? `<span style="color:#F4D92F">休学中</span>` : "已复学"
          }
        },
        {"prop": "handle", label: "操作", width: "180rem", handle: true,},
      ],
    }
  },
  created() {
    this.$store.commit("setPage", 1);
    this.$_register.get('api/recruit/common/consulting-school').then(res => {
      let data = res.data.data.physical_school;
      if (data.length === 0) return this.searchConfig[2].options = []
      data.unshift({
        id: "0",
        school_name: "全部"
      })
      this.searchConfig[2].options = data
    })
    this.$_axios.get("/site/grades").then(res => {
      let {data} = res.data;
      if (data.length === 0) return this.searchConfig[3].options = []
      data.unshift({
        id: "0",
        name: "全部"
      })
      this.searchConfig[3].options = data
    })
    this.init()
  },
  activated() {
    this.init()
  },
  computed: {
    ...mapState(["page"])
  },
  methods: {
    init() {
      const name = this.$route.query.student_name
      if (name) {
        this.$store.commit("setPage", 1);
        setConfigValue({ list: this.searchConfig, key: 'student_name', changeKey: 'default', value: name })
        this.search.student_name = name
      }
      this.getData()
    },
    onChange(val) { this.search = val },
    onReset() {
      this.searchConfig[4].options = []
      if (getConfigValue({list: this.searchConfig, key: 'student_name', valueKey: 'default'})) {
        setConfigValue({ list: this.searchConfig, key: 'student_name', changeKey: 'default' })
        this.$router.replace('./list')
      }
      this.search = {}
    },
    getData(val = {}) {
      this.loading = true;
      let params = {...this.search, page: this.page, ...val}
      if (!val.type) this.tableData = [];
      this.$_axios2('api/student/student-adjust/suspend-schooling', {params}).then(res => {
        if (!!params.type) return tools.download('休学名单', res.data)
        let data = res.data.data
        this.tableData = data.list
        this.total = data.page.total
      }).finally(() => {
        this.loading = false;
      })
    },

    onSearch(val) {
      this.$store.commit('setPage', 1);
      this.search = val;
      this.getData(val)
    },

    handleEdit(row, handle) {
      if (handle.type === 'view') {
        this.$router.push('./look?id=' + row.id + '&type=2')
      }
      if (handle.type === 'resumeSchooling') {
        this.$router.push('./edit?id=' + row.id)
      }
    },

    handleCurrentChange(val) {
      this.$store.commit("setPage", val);
      this.getData()
    },
    getClass(val) {
      if (val?.school_id && val?.grade_id) {
        let params = deepCopy(val)
        this.$_axios.get("/site/role-admin-class", {params}).then(res => {
          let {data} = res.data;
          if (data.length === 0) return this.searchConfig[5].options = data
          data.unshift({
            class_id: "0",
            class_name: "全部"
          })
          this.searchConfig[4].options = data
        })
      }
    },

    exportData() {
      this.getData({type: 1})
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
